import React, { FunctionComponent } from 'react';
import * as Icons from './activities';
import { FitnessApplicationActivityType } from '../../../../types/__generated__';

interface Props {
  type: FitnessApplicationActivityType;
}

const ICON_MAP: { [name: string]: React.FunctionComponent } = {
  [FitnessApplicationActivityType.Run]: Icons.RunIcon,
  [FitnessApplicationActivityType.Ride]: Icons.RideIcon,
  [FitnessApplicationActivityType.Walk]: Icons.WalkIcon,
  [FitnessApplicationActivityType.Hike]: Icons.HikeIcon,
  [FitnessApplicationActivityType.Swim]: Icons.SwimIcon,
  [FitnessApplicationActivityType.Wheelchair]: Icons.WheelchairIcon,
};

export const FitnessActivityIcon: FunctionComponent<Props> = ({ type }) => {
  const Component = ICON_MAP[type];
  return <Component />;
};
